export default __webpack_public_path__ + "static/media/Liciences.8bf441f6.jpg";